import { NSLabel } from 'bricks';
import { Dispatch, SetStateAction } from 'react';
import { FORM_LABEL_CLASS_NAME } from 'views/ProFormaTable/constants';
import NSInputNumberStepper from 'bricks/NSInputNumberStepper/NSInputNumberStepper';

export interface OperatingInfoValues {
    rentalGrowthPercentage: number;
    occupancyUponStabilizationPercentage: number;
    percentPreLeased: number;
    leaseUpPace: number;
    lengthOfLease: number;
    initialFreeRent: number;
    stabilizedFreeRent: number;
    generalVacancy: number;
    creditLoss: number;
}

interface OperatingInfoProps {
    setOperatingInfoValues: Dispatch<SetStateAction<OperatingInfoValues>>;
    values: OperatingInfoValues;
}

const OperatingInfo = ({ values, setOperatingInfoValues }: OperatingInfoProps) => {
    const handleChange = (key: keyof OperatingInfoValues, value: number | Date | null) => {
        setOperatingInfoValues(prevValues => ({
            ...prevValues,
            [key]: value,
        }));
    };

    return (
        <>
            <div className="ProFormaWizardStepOne__title">Operating information</div>
            <div className="ProFormaWizardStepOne__subtitle">Information about this investment's incoming revenue</div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>Occupancy upon stabilization</NSLabel>
                <NSInputNumberStepper
                    name="occupancyUponStabilizationPercentage"
                    value={values.occupancyUponStabilizationPercentage}
                    onChange={(count: number) => handleChange('occupancyUponStabilizationPercentage', count)}
                    min={0}
                    step={1}
                    max={100}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                    percentage
                />
            </div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>Rent growth (annual)</NSLabel>
                <NSInputNumberStepper
                    name="rentalGrowthPercentage"
                    value={Number(values.rentalGrowthPercentage)}
                    onChange={(count: number) => handleChange('rentalGrowthPercentage', count)}
                    percentage
                    min={0.1}
                    step={0.1}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                />
            </div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>% pre-leased</NSLabel>
                <NSInputNumberStepper
                    max={100}
                    percentage
                    name="percentPreLeased"
                    value={values.percentPreLeased}
                    onChange={(count: number) => handleChange('percentPreLeased', count)}
                    min={1}
                    step={1}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                />
            </div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>Lease-up pace (units/month)</NSLabel>
                <NSInputNumberStepper
                    name="leaseUpPace"
                    value={values.leaseUpPace}
                    onChange={(count: number) => handleChange('leaseUpPace', count)}
                    min={1}
                    step={1}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                />
            </div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>Length of lease (months)</NSLabel>
                <NSInputNumberStepper
                    name="lengthOfLease"
                    value={values.lengthOfLease}
                    onChange={(count: number) => handleChange('lengthOfLease', count)}
                    min={1}
                    step={1}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                />
            </div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>Initial free rent</NSLabel>
                <NSInputNumberStepper
                    name="initialFreeRent"
                    value={values.initialFreeRent}
                    onChange={(count: number) => handleChange('initialFreeRent', count)}
                    min={1}
                    step={1}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                />
            </div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>Stabilized free rent</NSLabel>
                <NSInputNumberStepper
                    name="stabilizedFreeRent"
                    value={values.stabilizedFreeRent}
                    onChange={(count: number) => handleChange('stabilizedFreeRent', count)}
                    min={1}
                    step={1}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                />
            </div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>General vacancy</NSLabel>
                <NSInputNumberStepper
                    percentage
                    max={100}
                    name="generalVacancy"
                    value={values.generalVacancy}
                    onChange={(count: number) => handleChange('generalVacancy', count)}
                    min={1}
                    step={1}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                />
            </div>
            <div className="d-flex align-items-center mt-2 w-50">
                <NSLabel className={FORM_LABEL_CLASS_NAME}>Credit loss</NSLabel>
                <NSInputNumberStepper
                    percentage
                    max={100}
                    name="creditLoss"
                    value={values.creditLoss}
                    onChange={(count: number) => handleChange('creditLoss', count)}
                    min={1}
                    step={1}
                    inputGroupClassName="ProFormaWizardStepOne__input-width"
                />
            </div>
        </>
    );
};

export default OperatingInfo;
